import React from "react";
import { TextTitle } from "ui/text";
import { AuraPlate } from "ui/plates";
import { AgentsVideo } from "components/platform/agents";
import { Box } from "@chakra-ui/react";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import { horizontalContainerPadding } from "ui/container";
import { sectionSpacingY } from "components/section";

export function AgentsVideoSection() {
  return (
    <Box as="section" maxW="container.section" mx="auto" px={horizontalContainerPadding}>
      <TextTitle
        theme="dark"
        align="center"
        size="lg"
        chip={{ text: "Hightouch Agents" }}
        title="Move faster across your entire marketing process"
        description="Hightouch Agents help answer questions, find opportunities, and automate workflows without extra steps or waiting around for other teams."
        maxW="700px"
      />

      <>
        <AgentsVideo
          clickableSpace="full"
          display={mobileOnlyDisplay()}
          borderColor="transparent"
          borderRadius="small"
          mb={sectionSpacingY.base}
        />
        <AuraPlate
          condensed
          theme="dark"
          display={desktopOnlyDisplay()}
          variant="blue"
          px="0"
          platePx={{ base: "0", md: "bigger" }}
          platePy={{ base: "0", md: "bigger" }}
        >
          <AgentsVideo clickableSpace="full" borderColor="transparent" borderRadius="bigger" mt="0" />
        </AuraPlate>
      </>
    </Box>
  );
}
